import { NgModule } from '@angular/core';
import { LibWarningFilledIconComponent } from './lib-warning-filled-icon.component';

@NgModule({
  declarations: [LibWarningFilledIconComponent],
  imports: [],
  exports: [LibWarningFilledIconComponent],
})
export class LibWarningFilledIconModule {}
